(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-video"] && !Shopify.designMode) return;
  try {
    class ProductCardVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;

      this.video.muted = true;
      this.video.playsInline = true;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.saveData = navigator.connection?.saveData === true;
      this.handleVisibilityChange = this.updatePlayback.bind(this);
      this.slide = this.closest('slideshow-slide');

      if (this.reducedMotion || this.saveData) {
        this.video.pause();
        this.video.removeAttribute('autoplay');
        return;
      }

      this.observer = new IntersectionObserver(
        ([entry]) => {
          this.visibleEnough = entry.isIntersecting && entry.intersectionRatio >= 0.5;
          this.updatePlayback();
        },
        { threshold: [0, 0.5] }
      );

      this.observer.observe(this);
      if (this.slide) {
        this.slideObserver = new MutationObserver(() => this.updatePlayback());
        this.slideObserver.observe(this.slide, {
          attributes: true,
          attributeFilter: ['aria-hidden', 'hidden'],
        });
      }
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.slideObserver?.disconnect();
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      this.video?.pause();
    }

    updatePlayback() {
      if (!this.video) return;

      const slideIsActive =
        !this.slide || (this.slide.hidden === false && this.slide.getAttribute('aria-hidden') !== 'true');

      if (this.visibleEnough && slideIsActive && document.visibilityState === 'visible') {
        this.video.play().catch(() => {});
      } else {
        this.video.pause();
      }
    }
  }

  if (!customElements.get('product-card-video')) {
    customElements.define('product-card-video', ProductCardVideo);
  }
  } catch(e) { console.error(e); }
})();

})();
